import React from 'react';
import '../styles/home.css';


class About extends React.Component{
    
    render(){
        return(
            <div class="about-box">
                <p>
                    My name is <b>Pooya Oladazimi</b>. I am a software developer.
                </p>

                <p>
                    Software development is magic. So I like to consider myself as <i><a href="https://en.wikipedia.org/wiki/Gandalf"  target="_blank">Gandalf</a></i>. 
                </p>

                <p>
                    My hobbies are watching movies/series (Fantasy as much as possible), lifting some weight, 
                    cycling, and reading 
                    blog posts. <br></br>
                    Oh and PlayStation!
                </p>
            </div>
        );
    }
}

export default About;